// The ticket mark's shape (spec §6), in one place: TicketMark and anything else drawing a ticket type read it from here, so a new shape is one edit.
// A landscape card with one corner cut at 45° top right: the cut of the logo (docs/brand/logo), as a ticket.
export const TICKET_MARK = {
  width: 20,
  height: 12,
  points: '0,0 15.5,0 20,4.5 20,12 0,12',
  // The same outline for an extra, drawn hollow: inset by half the 1.5 stroke so it lines up with a ticket
  hollow: '0.75,0.75 15.2,0.75 19.25,4.8 19.25,11.25 0.75,11.25',
} as const;
